import { Button, Form, Input, message, Modal } from 'antd'
import React, { FunctionComponent, useCallback, useMemo, useState } from 'react'

import { useEditPropertyListMutation } from '../../../graphql/generated'
import { useToggleState } from '../../utils/useToggleState'
import { PropertyListTableItem } from '../PropertyListTable/PropertyListTable'

export interface PropertyListEditModalButtonProps {
  record: PropertyListTableItem
  buttonClassName?: string
}

export const PropertyListEditModalButton: FunctionComponent<PropertyListEditModalButtonProps> =
  props => {
    const [isOpen, toggleOpen] = useToggleState(false)
    const [name, setName] = useState(props.record.name)
    const [description, setDescription] = useState(
      props.record.description || ''
    )

    const [, editPropertyList] = useEditPropertyListMutation()

    const handleSave = useCallback(async () => {
      const variables = {
        name: name.trim(),
        description: description.trim() || null,
      }

      try {
        const result = await editPropertyList({
          id: props.record.id,
          ...variables,
        })

        if (result.error) {
          message.error('Nepodařilo se uložit změny')
          return
        }

        message.success('Změny byly úspěšně uloženy')
        toggleOpen()
      } catch (e) {
        message.error('Nepodařilo se uložit seznam nemovitostí')
      }
    }, [name, description, editPropertyList, props.record.id, toggleOpen])

    const okButtonProps = useMemo(
      () => ({ disabled: name.trim().length === 0 }),
      [name]
    )

    return (
      <>
        <Button
          onClick={toggleOpen}
          className={props.buttonClassName}
          title="Editovat seznam nemovitostí"
          ghost
          type="link"
        >
          Editovat
        </Button>
        {isOpen && (
          <Modal
            title={`Editace seznamu "${props.record.name}"`}
            open={isOpen}
            onOk={handleSave}
            onCancel={toggleOpen}
            okText="Uložit"
            cancelText="Zrušit"
            okButtonProps={okButtonProps}
          >
            <Form layout="vertical">
              <Form.Item label="Název" required>
                <Input
                  placeholder="Např. Budovy v Praze 6"
                  value={name}
                  onChange={e => setName(e.target.value)}
                />
              </Form.Item>
              <Form.Item label="Popis">
                <Input.TextArea
                  rows={3}
                  placeholder="Krátký popis seznamu"
                  value={description}
                  onChange={e => setDescription(e.target.value)}
                />
              </Form.Item>
            </Form>
          </Modal>
        )}
      </>
    )
  }
